<template>
  <div class="page" :class="{'has-banner': !(banners && banners.length)}">
    <div class="share-banner" v-if="banners && banners.length">
      <!--  -->
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, i) in banners" :key="i"><img :src="item.operationUrl" alt="" @click="bannerClick(item)"></van-swipe-item>
      </van-swipe>
    </div>
    <ud-sheet-bar :options="tabOptions" :current.sync="current" />
    <ud-empty-row height="14" />
    <div v-if="current === 0">
      <header class="header">
        <div class="header-wrap">
          <div class="header-input">
            <div class="header-province" @click="handleChooseProvince">
              <span>{{ province }}</span>
            </div>
            <div class="header-box">
              <div class="header-box-item" :class="{'active': licensePlate.length === 0 && isFocus }">{{ licensePlate && licensePlate.substring(0, 1) }}</div>
              <div class="header-box-line">-</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 1 && isFocus }">{{ licensePlate && licensePlate.substring(1, 2) }}</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 2 && isFocus }">{{ licensePlate && licensePlate.substring(2, 3) }}</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 3 && isFocus }">{{ licensePlate && licensePlate.substring(3, 4) }}</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 4 && isFocus }">{{ licensePlate && licensePlate.substring(4, 5) }}</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 5 && isFocus }">{{ licensePlate && licensePlate.substring(5, 6) }}</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 6 && isFocus }">
                <div v-if="licensePlate.length > 6 || isFocus">
                  {{ licensePlate && licensePlate.substring(6, 7)  }}
                </div>
                <div class="header-box-item-placeholder" v-else>
                  <img src="@/assets/image/home-add.png" alt="">
                  <div class="desc">新能源</div>
                </div>
              </div>
            </div>
          </div>
          <input type="text" id="inputNode" v-model="licensePlate" maxlength="7" @input="handleInputChange" @focus="handleFocus" @blur="handleBlur" />
        </div>
        <div class="header-history">
          <div class="header-history-item" v-for="(item, i) in historyList" :key="i" @click="handleHistory(item)">{{ item }}</div>
        </div>
        <div class="header-query" @click="handleGetInfo(false)">
          <span>查询停车费</span>
        </div>
      </header>
      <ud-empty-row height="14" />
      <main class="main">
        <div class="main-info">
          <template v-for="(item, index) in columns">
            <ud-row
              :key="index"
              :label="item.label"
              :value="item.value"
              :border="index < columns.length - 1"
            />
          </template>
        </div>
        <ud-empty-row height="28" />
        <!-- <ud-pay-list :current.sync="payCurrent" :list="payList" /> -->
        <ud-empty-row height="48" />
        <div class="main-btn" @click="handlePay">
          <span>确认支付</span>
        </div>
      </main>
    </div>
    <!-- 月卡延期 -->
    <div v-else>
      <header class="header">
        <div class="header-wrap">
          <div class="header-input">
            <div class="header-province" @click="handleChooseProvince">
              <span>{{ province }}</span>
            </div>
            <div class="header-box">
              <div class="header-box-item" :class="{'active': licensePlate.length === 0 && isFocus }">{{ licensePlate && licensePlate.substring(0, 1) }}</div>
              <div class="header-box-line">-</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 1 && isFocus }">{{ licensePlate && licensePlate.substring(1, 2) }}</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 2 && isFocus }">{{ licensePlate && licensePlate.substring(2, 3) }}</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 3 && isFocus }">{{ licensePlate && licensePlate.substring(3, 4) }}</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 4 && isFocus }">{{ licensePlate && licensePlate.substring(4, 5) }}</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 5 && isFocus }">{{ licensePlate && licensePlate.substring(5, 6) }}</div>
              <div class="header-box-item" :class="{'active': licensePlate.length === 6 && isFocus }">
                <div v-if="licensePlate.length > 6 || isFocus">
                  {{ licensePlate && licensePlate.substring(6, 7)  }}
                </div>
                <div class="header-box-item-placeholder" v-else>
                  <img src="@/assets/image/home-add.png" alt="">
                  <div class="desc">新能源</div>
                </div>
              </div>
            </div>
          </div>
          <input type="text" id="inputNode" v-model="licensePlate" maxlength="7" @input="handleInputChange" @focus="handleFocus" @blur="handleBlur" />
        </div>
        <div class="header-history">
          <div class="header-history-item" v-for="(item, i) in historyList" :key="i" @click="handleHistory(item)">{{ item }}</div>
        </div>
        <div class="header-query" @click="handleGetInfo(true)">
          <span>查询月卡</span>
        </div>
      </header>
      <ud-empty-row height="14" />
      <div v-if="cardInfo && cardInfo.length > 0">
        <ud-card class="item-row-wrap">
          <div v-for="(item, index) in cardInfo" :key="index">
            <div class="item-row" @click="chooseCard(item)">
              <img v-if="!item.selected" src="https://oss-public.uopgenjoy.com/prod/static/property/images/icons/icon-check.png" alt="" width="20px" />
              <img v-else src="https://oss-public.uopgenjoy.com/prod/static/property/images/icons/icon-checked.png" alt="" width="20px" />
              <div class="item-centent">
                <div class="item-row-header">
                  <div class="item-row-header-left">
                    <span class="item-row-header-left-title">{{item.projectName}}-{{ item.cardName }}</span>
                    
                  </div>
                  <div class="item-row-header-right">
                    <span :class="['item-row-header-left-status', statusColor(item.status)]">{{filterStatus(item.status)}}</span>
                  </div>
                </div>
                <div class="item-row-body">
                  <div class="item-row-line">
                    <div class="item-row-line-label">停车场</div>
                    <div class="item-row-line-value">{{ item.carParkName }}</div>
                  </div>
                  <div class="item-row-line">
                    <div class="item-row-line-label">车牌号码</div>
                    <div class="item-row-line-value">{{ item.parkingNumber }}</div>
                  </div>
                  <div class="item-row-line">
                    <div class="item-row-line-label">生效时间</div>
                    <div class="item-row-line-value">{{ item.effectTime }}</div>
                  </div>
                  <div class="item-row-line">
                    <div class="item-row-line-label">失效时间</div>
                    <div class="item-row-line-value">{{ item.loseEfficacyTime }}</div>
                  </div>
                  <div class="item-row-line">
                    <div class="item-row-line-label">月卡单价</div>
                    <div class="item-row-line-value">{{ (item.periodMoney ? item.periodMoney : '0') + '元/月' }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 失效提示语 -->
            <div class="item-tips" v-if="item.status === '1' && item.failurePrompt">{{item.failurePrompt}}</div>
          </div>
        </ud-card>
        <ud-empty-row height="14" />
        <ud-card class="main-info-wrap">
          <div class="line">
            <div class="name">申请周期(月)</div>
            <div class="val">
              <div class="data-picker" @click="handleSelect">
                {{ applyPeriod.label }}
                <!-- <uni-icons type="bottom" size="20" color="rgba(0, 0, 0, 0.25)" /> -->
                <img src="https://oss-public.uopgenjoy.com/prod/static/property/images/icons/icon-arrowdown-02.png" alt="" width="16px" />
              </div>
            </div>
          </div>
          <div class="line">
            <div class="name">应缴金额(元)</div>
            <div class="val money">{{totalMoney}}</div>
          </div>
          <!-- <div class="line">
            <div class="name">支付方式</div>
            <div class="val">
              <div class="pay-list">
                <div class="item active" v-for="(item, index) in payListData" :key="index">
                  <img class="item-icon" :src="item.icon" mode="widthFix" />
                  <span class="item-label">{{item.label}}</span>
                </div>
              </div>

            </div>
          </div> -->
        </ud-card>
        <ud-empty-row height="14" />
        <!-- footer -->
        <div class="footer-wrap">
          <!-- <div class="form-treaty">
            <treaty-row :value.sync="isAgree" />
          </div> -->
          <ud-empty-row height="12" />
          <div class="main-btn" @click="handleCardPay">
            <span>确认支付</span>
          </div>
        </div>
      </div>
      <uop-list-empty v-else pic="https://oss-public.uopgenjoy.com/prod/static/property/images/global/img-empty-02.png" :height="70"></uop-list-empty>
    </div>

    <ud-car-province ref="carProvince" @confirm="handleChooseProvinceConfirm" />
    <!-- 选择类型 -->
		<van-popup v-model="commonSelectPopup" position="bottom" :style="{ height: '40%' }">
      <div class="popup-list">
        <div class="item" :class="{'active' : applyPeriod.value === item.value}" v-for="(item, index) in commonSelectOptions" :key="index" @click="handleSelectConfirm(item)">{{item.label}}</div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog, Toast, Popup } from 'vant'
import moment from 'moment'
import { NetService } from '@/service'

import UdEmptyRow from '@/components/ud-empty-row'
import UdRow from '@/components/ud-row'
// import UdPayList from '@/components/ud-pay-list'
import UdCarProvince from '@/components/ud-car-province'
import UdSheetBar from '@/components/ud-sheet-bar'
import UdCard from '@/components/ud-card'
// import TreatyRow from '@/components/treaty-row'
// import UdSelectPicker from '@/components/ud-select-picker'
import UopListEmpty from '@/components/uop-list-empty'
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Popup)

export default {
  components: {
    UdEmptyRow,
    UdRow,
    // UdPayList,
    UdCarProvince,
    UdSheetBar,
    UdCard,
    // TreatyRow,
    // UdSelectPicker,
    UopListEmpty
  },
  filters: {
    getFormatDate(date = '0') {
      if (!date || date <= 0) {
        return ''
      }
      date = moment.duration(date, 'seconds')
      return`${parseInt(date.asDays())}天${date.hours()}小时${date.minutes()}分`
    }
  },
  data() {
    return {
      carParkId: '',
      province: '粤',
      licensePlate: '',
      columns: [
        { label: '车场名称：', prop: 'carParkName', value: '' },
        { label: '进场时间：', prop: 'entranceTime', value: '' },
        { label: '离场时间：', prop: 'comeTime', value: '' },
        { label: '已停时长：', prop: 'pausedTimeStr', value: '' },
        { label: '应缴金额：', prop: 'paidInMoney', value: '' },
      ],
      columnsData: '',
      // payCurrent: 0,
      tabOptions: ['临时停车收费', '月卡延期'],
      // payList: [],
      historyList: [],
      orderInfo: null,
      isFocus: false,
      current: 0,
      commonSelectPopup: false,
      commonSelectOptions: [
				{
					label: '1个月',
					value: 1,
				}, {
					label: '2个月',
					value: 2,
				}, {
					label: '3个月',
					value: 3,
				}, {
					label: '4个月',
					value: 4,
				}, {
					label: '5个月',
					value: 5,
				}, {
					label: '6个月',
					value: 6,
				}, {
					label: '7个月',
					value: 7,
				}, {
					label: '8个月',
					value: 8,
				}, {
					label: '9个月',
					value: 9,
				}, {
					label: '10个月',
					value: 10,
				}, {
					label: '11个月',
					value: 11,
				}, {
					label: '12个月',
					value: 12,
				}],
				applyPeriod: {
					label: '1个月',
					value: 1,
				},
        totalMoney: 0,
        cardInfo: [],
        // 是否同意协议
				isAgree: false,
        payIndex: 0,
        // payListData: [],
        banners: []
    }
  },
  mounted() {
    let query = this.getURLParameters(window.location.href)
    let carParkId = query.carParkId
    if (!carParkId) {
      Dialog({ message: '二维码有误，请重试' })
    } else {
      this.carParkId = carParkId
      if (this.carParkId === '41692397') {
        this.tabOptions = ['临时停车收费']
      }
      // this.getUserAgent()
    }
    const historyData = localStorage.getItem('genjoyCarNo')
    this.historyList = historyData ? JSON.parse(historyData) : []
    this.getBanners()
  },
  created() {
  },
  methods: {
    getBanners() {
      NetService.GetBanners({ isNormal: 1, operationPlaceType: 4, operationType: 2, carParkId: this.carParkId}).then(res => {
        this.banners = res
      })
    },
    bannerClick(item) {
      NetService.AddClickRate(item.id).then(() => {
        switch (item.operationTargetType){
						case 0:
							break
						case 1:
              location.href = item.operationTargetUrl
							break
						case 2:
							break
						case 3:
							break
						case 4:
							break
						default:
							break
					}
      })
    },
    handleGetInfo(isMonthCard) { // handleGetInfo(carNum) {
      const carNum = this.province + this.licensePlate
      if (!this.isPlateNo(carNum)) {
        Toast('输入的车牌格式有误')
        return false
      }
      const historyData = JSON.parse(JSON.stringify(this.historyList))
      if (!historyData.includes(carNum)) {
        if (historyData.length === 3) {
          historyData.shift()
        }
        historyData.push(carNum)
        this.historyList = historyData
        localStorage.setItem('genjoyCarNo', JSON.stringify(this.historyList))
      }
      // 是否查询月卡
      if(isMonthCard) {
        this.handleCardInfo(carNum)
      } else {
        const data = {
          carNum: carNum.toUpperCase(),
          carParkId: this.carParkId
          // carParkId: '41692533'
        }
        let loading = Toast.loading({ duration: 0, message: '加载中...' })
        NetService.CreateOrder(data).then(res => {
          loading.clear()
          this.orderInfo = res ? res : []
          this.setColumnsValue(res)
        }).catch(err => {
          loading.clear()
          this.orderInfo = []
          this.resetColumnsValue()
          Toast(err.msg || '出错了，请重试')
        })
      }
    },
    resetColumnsValue() {
      this.columns = this.columns.map(item => {
          item.value = ''
        return item
      })
    },
    setColumnsValue(data) {
      this.columns = this.columns.map(item => {
        if (Object.hasOwnProperty.call(data, item.prop)) {
          item.value = String(data[item.prop])
        }
        return item
      })
    },
    // 去支付
    async handlePay() {
      if (!this.orderInfo) {
        return Toast('请先查询车辆')
      }
      let loading = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...',
      })
      try {
        // if (!this.payList.length) {
        //   Toast('请使用支付宝或者微信扫码支付')
        //   return false
        // }
        if (!this.orderInfo.licensePlate) return Toast('未查询到车辆信息')
        let amount = this.orderInfo.paidInMoney
        const payCacheOrders = {
          businessType: 4,  //1.装修 2.入伙 3.月卡缴费 4.临停缴费 5.分账支付
          faretypeId: this.orderInfo.faretypeId,
          orderAmount: amount,
          // sourceId: this.orderInfo.carId,
          orderOtherInformationList: [this.orderInfo],
          // payType: this.payList[this.payCurrent].value,
          orderSource: 2  // 订单来源 (1. App 2. H5)
        }

        console.log(payCacheOrders, '-----')
        let confirmOrderInfo = await NetService.cacheOrders(payCacheOrders)
       
        let { counter_url } = await NetService.deferredPaymentOfMonthlyCard({
          amount,
          exterMerOrderNo: confirmOrderInfo,
          subject: '停车缴费',
        })
        window.location.href = counter_url
        // const data = Object.assign({}, this.orderInfo, {
        //   isApp: true,
        //   payType: this.payList[this.payCurrent].value
        // })
        // delete data.id
        // let confirmOrderInfo = await NetService.ConfirmOrder(data)
        // let amount = String(parseInt(this.orderInfo.paidInMoney * 100))
        // let { qrCodeUrl } = await NetService.PayOrder({
        //   amount,
        //   exterMerOrderNo: confirmOrderInfo.systemOrderNo,
        //   subject: this.orderInfo.carParkName,
        // })
        // window.location.href = qrCodeUrl
      } catch (e) {
        loading.clear()
        Toast(e.msg || '出错了，请重试')
      }
    },
    getURLParameters(url) {
      console.log(url)
      return (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
        (a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a), {}
      )
    },
    isPlateNo(value) {
      const reg = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Z]{1}[a-zA-Z0-9]{5}[A-Z0-9挂学警港澳]{1})$|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
      return reg.test(value)
    },
    handleChooseProvince() {
      this.$refs.carProvince.open()
    },
    handleChooseProvinceConfirm(val) {
      this.province = val
      // this.handleGetInfo(this.province + this.licensePlate)
    },
    handleInputChange() {
      this.licensePlate = this.licensePlate.toUpperCase()
      // this.handleGetInfo(this.province + this.licensePlate)
    },
    handleFocus() {
      this.isFocus = true
      const node = document.getElementById('inputNode')
      if (window.getSelection) {
        let range = window.getSelection()
        range.selectAllChildren(node)
        range.collapseToEnd()
      } else if (document.selection) {
        let range = document.selection.createRange()
        range.moveToElementText(node)
        range.collapse(false)
        range.select()
      }
    },
    // 失焦隐藏
    handleBlur() {
      this.isFocus = false
    },
    handleHistory(item) {
      this.province = item.substring(0, 1)
      this.licensePlate = item.slice(1)
    },
    // 浏览器
    // getUserAgent() {
    //   const userAgent = navigator.userAgent.toLowerCase()
    //   if(userAgent.match(/Alipay/i) == "alipay") {
    //     this.payList.push({ label: '支付宝支付', icon: require('@/assets/image/icon-alipay-01.png'), value: 5 })
    //     this.payListData.push({ label: '支付宝', icon: 'https://oss-public.uopgenjoy.com/prod/static/property/images/icons/icon-alipay-03.png', value: 5 })
    //   } else if(userAgent.match(/MicroMessenger/i) == "micromessenger") {
    //     this.payList.push({ label: '微信支付', icon: require('@/assets/image/icon-wechat-01.png'), value: 4 })
    //     this.payListData.push({ label: '微信', icon: 'https://oss-public.uopgenjoy.com/prod/static/property/images/icons/icon-wechat-03.png', value: 4 })
    //   }
    // },
    // 打开选择周期
    handleSelect() {
      this.commonSelectPopup = true
      
    },
    // 周期选择
    handleSelectConfirm(data) {
      this.applyPeriod = data
      this.commonSelectPopup = false
      this.setMoney()
    },
    // 查询月卡信息
    handleCardInfo(carNum) {
      const data = {
        parkingNumber: carNum.toUpperCase(),
        carParkId: this.carParkId,
      }
      let loading = Toast.loading({ duration: 0, message: '加载中...' })
      NetService.GetCardInformation(data).then(res => {
        loading.clear()
        if(res && res.length > 0) {
          res.forEach(item => {
            item.selected = true
          })
        }
        this.cardInfo = res ? res : []
        this.setMoney()
      }).catch(err => {
        loading.clear()
        this.cardInfo = []
        Toast(err.msg || '出错了，请重试')
      })
    },
    filterStatus(status) {
      if(status === '0') {
        return '生效'
      } else if(status === '1') {
        return '已失效'
      } else if(status === '2') {
        return '已注销'
      }
    },
    statusColor(status) {
      if(status === '0') {
        return 'color-green'
      } else if(status === '1') {
        return 'color-red'
      } else if(status === '2') {
        return 'color-grey'
      }
    },
    chooseCard(e) {
      this.cardInfo.forEach(item => {
        if(item.carId === e.carId) {
          item.selected = !item.selected
        }
      })
      this.setMoney()
    },
    // 金额计算
    setMoney() {
      const newArr = this.cardInfo.filter(item => { return item.selected})
      this.totalMoney = 0
      if(newArr && newArr.length > 0) {
        newArr.map(item => {
          this.totalMoney += parseFloat(item.periodMoney)
        })
        this.totalMoney = this.totalMoney * this.applyPeriod.value
      }
    },
    // 月卡支付
    async handleCardPay() {
      const index = this.cardInfo.findIndex(item => { return item.selected})
      if(index === -1) {
        Toast('请选择月卡信息')
        return false
      }
      // if(!this.isAgree) {
      //   Toast('请确认停车管理协议')
      //   return false
      // }
      let loading = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...',
      })
      try {
        // if (!this.payListData.length) {
        //   Toast('请使用支付宝或者微信扫码支付')
        //   return false
        // }
        const orderOtherInformationList = this.cardInfo.filter(item => { return item.selected})
        orderOtherInformationList.map(item => {
          item.applyPeriod = this.applyPeriod.value
        })
        const payCacheOrders = {
          businessType: 3,  //1.装修 2.入伙 3.月卡缴费 4.临停缴费 5.分账支付
          faretypeId: orderOtherInformationList[0].faretypeId,
          orderAmount: this.totalMoney,
          sourceId: orderOtherInformationList[0].carId,
          orderOtherInformationList: orderOtherInformationList,
          // payType: this.payListData[this.payIndex].value,
          orderSource: 2  // 订单来源 (1. App 2. H5)
        }
        console.log(payCacheOrders, '-----')
        let confirmOrderInfo = await NetService.cacheOrders(payCacheOrders)

        let amount = String(this.totalMoney)
        let { counter_url } = await NetService.deferredPaymentOfMonthlyCard({
          amount,
          exterMerOrderNo: confirmOrderInfo,
          subject: '月卡缴费',
        })
        window.location.href = counter_url
      } catch (e) {
        loading.clear()
        Toast(e.msg || '出错了，请重试')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
	min-height: 100vh;
	background-color: $color-bg;
  padding-top: 266px;
	@extend .flex-column;
  &.has-banner {
    padding-top: 0;
    .sheet {
      top: 0;
    }
    .heander {
      margin-top: 0;
    }
  }
  .sheet{
    position: fixed;
    left: 0;
    top: 266px;
    right: 0;
    z-index: 2;
  }
}

.header,
.main {
	margin: 0 20px;
  border-radius: 4px;
}

.header {
	background: $color-white;
  padding: 30px 8px;
  margin-top: 75px;
  &-wrap {
    position: relative;
    input {
      position: absolute;
      top: 0;
      opacity: 0;
      height: 65px;
      left: 75px;
      z-index: 5;
      width: 460px;
      font-size: 30px;
      letter-spacing: 40px;
    }
  }
  &-input{
    display: flex;
    align-items: center;
    position: relative;
    z-index: 1;
  }
  &-box {
    display: flex;
    align-items: center;
    &-line {
      padding: 0 0;
      @include text;
    }
    &-item {
      border: 1px solid $color-border;
      border-radius: 6px;
      width: 50px;
      height: 60px;
      flex: 1;
      margin: 0 7px;
      @include text(28px);
      @extend .flex-row-center;
      &-placeholder {
        font-size: 12px;
        text-align: center;
        color: #D5D5D5;
      }
      &.active {
        &:before {
          border-left: 1px solid #000;
          box-sizing: border-box;
          height: 38px;
          margin-top: 3px;
          margin-left: 5px;
          content: '';
          display: block;
        }
      }
      span {
        @include text(28px);
      }
    }
  }
	&-province {
		border: 1px solid $color-border;
		border-radius: 6px;
		width: 50px;
		height: 60px;
    margin: 0 7px;

		@extend .flex-row-center;
		span {
			@include text(28px);
		}
	}
  &-history {
    margin: -15px 10px 0 10px;
    &-item {
      display: inline-block;
      background: #F6F6F6;
      padding: 10px 15px;
      margin-right: 20px;
      color: #9B9B9B;
      font-size: 18px;
    }
  }
	
	&-query {
    border-top: 1px solid #F5F5F5;
    text-align: center;
    // height: 60px;
    // line-height: 60px;
    
    padding-top: 25px;
    color: #ff8541;
    font-size: 24px;
    margin-top: 25px;
	}
}

.main {
	&-info {
		background: $color-white;
	}
	&-btn {
		border-radius: 10px;
		height: 70px;
		background-color: #FF8541;

		@extend .flex-row-center;
		span {
			@include text(23px, 400, $color-white);
		}
    &.disabled{
      background-color: #999999;
    }
	}
}

.main-info-wrap{
	padding: 25px 20px;
  margin: 0 20px;
  border-radius: 4px;
	.line{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 24px;
		margin-top: 26px;
		&:first-child{
			margin-top: 0;
		}
		.money{
			@include text(32px, 500, #FF5C50);
		}
	}
	.data-picker{
		width: 122px;
		height: 38px;
		padding: 0 8px;
		background: #FFFFFF;
		border-radius: 6px;
		opacity: 1;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border: 2px solid #D9D9D9;
		@include text(16px, 400, rgba(0, 0, 0, 0.25));
	}
	.pay-list{
		display: flex;
		.item{
			width: 120px;
			height: 38px;
			background: #F6F6F6;
			border-radius: 6px;
			margin-left: 15px;
			display: flex;
			justify-content: center;
      align-items: center;
			line-height: 38px;
			font-size: 20px;
			&.active{
				background: #FF8B5C;
				color: $color-white;
			}
			&-icon{
				width: 22px;
				height: 22px;
				margin: 0 6px 0 0;
			}
		}
	}
}
.footer-wrap{
	padding: 0 20px 88px;
}
.item-row-wrap{
  margin: 0 20px;
  border-radius: 4px;
  .item-tips{
		border-top: 1px solid #F5F5F5;
		padding: 20px 30px;
    font-size: 12px;
    color: #9B9B9B;
	}
}
.item-row {
		padding: 30px 20px;
		display: flex;
		align-items: center;
		// border-top: 1px solid $color-border;
		.item-centent{
			flex: 1;
			margin-left: 20px;
			.item-row-line-label{
				width: 140px;
			}
			.item-row-line-value{
				flex: 1;
			}
		}
		&-header {
			@extend .flex-row;
			align-items: center;
			justify-content: space-between;
		
			&-left {
				@extend .flex-row;
				align-items: center;
		
				&-title {
					flex: 1;
					@include text(26px, 400);
					@include ellipsis();
				}
		
				&-status {
					@include text(26px, 400);
		
					&.color-green {
						color: rgba(65, 185, 105, 1);
					}
		
					&.color-grey {
						color: $color-grey;
					}
		
					&.color-orange {
						color: rgba(255, 196, 110, 1);
					}
		
					&.color-red {
						color: rgba(255, 92, 92, 1);
					}
				}
			}
		
			&-right {
				@extend .flex-row;
			}
		}
	}
  .item-row-line {
    // height: 54rpx;
    padding-top: 15px;
    @extend .flex-row;
    justify-content: space-between;
    align-items: center;
    line-height: 1.5;
    &-label {
      width: 140px;
      @include text(24px, 400, $color-grey);
    }
    &-value {
      flex: 1;
      text-align: right;
      @include text(24px, 400, $color-grey);
    }
  }
  .popup-list{
    padding: 20px 30px;
    .item{
      padding: 20px;
      @include text(24px, 400, $color-grey);
      text-align: center;
      &.active{
        color: #FF8B5C;
      }
    }
  }
  .share-banner {
    margin: 20px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    img {
      width: 100%;
      height: 226px;
    }
    .my-swipe {

    }
  }
</style>
